import { useContext } from 'react';
import { AmicaleContext } from '../context/AmicaleContext';

const useAmicale = () => useContext(AmicaleContext);

export default useAmicale;
